/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import { css, cx } from '@emotion/css';
const styles = {
  container: css({
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  }),
};
type Device = {
  width: number;
  height: number;
  backgroundImage: string;
};
type Props = {
  children?: React.ReactNode;
  containerClassName?: string;
  device: Device;
  deviceStyles?: string;
  testid: string;
  deviceDropdown?: React.ReactElement<any>;
};

class DevicePreviewer extends React.PureComponent<Props> {
  render() {
    const { children, containerClassName, deviceStyles, device, testid, deviceDropdown } = this.props;
    const { container } = styles;
    return (
      <div className={cx(container, containerClassName)} data-testid={`${testid}__device-previewer`}>
        {deviceDropdown}
        <div className={cx(css(device), deviceStyles)}>{children}</div>
      </div>
    );
  }
}

export default DevicePreviewer;
